import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectPlanFolderModel } from '../models/projectplan.model';
import { ApiService } from '../core/services/api.service';
import { ProjectFileFolderModel, ProjectFileModel } from '../models/projectfile.model';

export interface ProjectFileAnnotationModel {
  fileId?: number;
  annotationXfdf?: string | null;
  annotationUpdatedBy?: number | null;
  annotationUpdatedAt?: string | Date | null;
}

@Injectable({
  providedIn: 'root'
})
export class ProjectfileService {
  constructor(private apiService: ApiService) { }

  addProjectFileFolder(folderData: ProjectFileFolderModel): Observable<number> {
    return this.apiService.post('ProjectFile/CreateProjectFileFolder', folderData);
  }

  getProjectFiles(projectId: number): Observable<ProjectFileFolderModel[]> {
    return this.apiService.get(`ProjectFile/GetProjectFiles/${projectId}`);
  }

  addProjectFile(fileData: any): Observable<number> {
    return this.apiService.post('ProjectFile/AddProjectFile', fileData);
  }

  /**
  * Update project file (e.g. rename)
  */
  updateProjectFile(model: ProjectFileModel): Observable<any> {
    return this.apiService.put('ProjectFile/UpdateProjectFile', model);
  }

  getProjectFileAnnotation(fileId: number): Observable<ProjectFileAnnotationModel> {
    return this.apiService.get(`ProjectFile/GetProjectFileAnnotation/${fileId}`);
  }

  updateProjectFileAnnotation(fileId: number, annotationXfdf: string | null): Observable<any> {
    return this.apiService.put(`ProjectFile/UpdateProjectFileAnnotation/${fileId}`, { annotationXfdf });
  }

  downloadProjectFile(fileId: number): Observable<Blob> {
    return this.apiService.getBlob(`ProjectFile/DownloadProjectFile/${fileId}`);
  }

  /**
  * Bulk delete files and folders
  */
  bulkDeleteProjectFiles(fileIds: number[], folderIds: number[]): Observable<any> {
    return this.apiService.post('ProjectFile/BulkDeleteProjectFiles', { fileIds, folderIds });
  }

  /**
  * Delete project file
  */
  deleteProjectFile(fileId: number): Observable<any> {
    return this.apiService.delete(`ProjectFile/DeleteProjectFile/${fileId}`);
  }

  /**
  * Delete project file folder (includes all nested folders and files)
  */
  deleteProjectFileFolder(fileFolderId: number): Observable<any> {
    return this.apiService.delete(`ProjectFile/DeleteProjectFileFolder/${fileFolderId}`);
  }

  getProjectFolderNames(projectId: number): Observable<{ fileFolderId: number; folderName: string }[]> {
    return this.apiService.get(`ProjectFile/GetProjectFolderNames/${projectId}`);
  }

  downloadFolderAsZip(folderId: number): Observable<Blob> {
    return this.apiService.getBlob(`ProjectFile/DownloadFolderAsZip/${folderId}`);
  }

  syncTestReports(projectId: number, reportType: string, sourcePath: string, destinationFolderId: number): Observable<{ message: string }> {
    return this.apiService.post(`ProjectFile/SyncTestReports/${projectId}`, {
      reportType,
      sourcePath,
      destinationFolderId
    });
  }

}
